




































import BtnDefault from '@/components/UI/BtnDefault.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import DialogFooter from '@/components/UI/DialogFooter.vue';
import {namespace} from 'vuex-class';
import WaveSurfer from "wavesurfer.js";

const dialog = namespace('dialog')
const forms = namespace('forms')
const surveys = namespace('surveys')

@Component({
  components: {
    BtnDefault,
    DialogFooter,
  },
  name: "AddComentForm"
})
export default class AddComentForm extends Vue {

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @forms.Getter('options') protected options:any
  @surveys.Getter('survey') protected survey:any

  other:boolean = false
  comment:any = {
    answerTitle: '',
    answers: [],
    text: '',
    type: 'text_container',
    help: '',
    specify: 'default'
  }

  @Watch('fullDialogShow')
  setSignature() {
    if(!this.fullDialogShow) {
      this.comment = {
        answerTitle: '',
        answers: [],
        text: '',
        type: 'text_container',
        help: '',
        specify: 'default'
      }
    }
  }

  save() {
    this.comment.isNew = true
    this.survey.questions.push(this.comment)
    this.SetFullDialogShow(false)
  }
  

}
